import React from 'react';
import './DestinationDetailHero.css';

function DestinationDetailHero({ destination }) {
  return (
    <section className="destination-detail-hero">
      <div 
        className="destination-detail-hero-background"
        style={{
          backgroundImage: `url('${destination.image}')`
        }}
      >
        <div className="destination-detail-hero-overlay"></div>
      </div>
      <div className="destination-detail-hero-content">
        <div className="destination-detail-hero-badge">
          {destination.category}
        </div>
        <h1 className="destination-detail-hero-title">{destination.name}</h1>
        <p className="destination-detail-hero-subtitle">{destination.description}</p>
        <div className="destination-detail-hero-info">
          <div className="hero-info-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12 6 12 12 16 14"/>
            </svg>
            <span>{destination.duration}</span>
          </div>
          <div className="hero-info-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
            <span>Best: {destination.bestTime}</span>
          </div>
          <div className="hero-info-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
            <span>{destination.location}</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DestinationDetailHero;

